import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useContent } from "../../lib/content";

export const Footer = () => {
  const c = useContent().company;
  return (
    <footer data-testid="site-footer" className="relative border-t hairline bg-[#050811]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo size="lg" />
          <p className="mt-5 max-w-sm text-sm text-slate-400 leading-relaxed">Programma di acquisizione clienti per aziende di pompe di calore, climatizzazione e fotovoltaico.</p>
        </div>
        <div className="md:col-span-3 text-sm space-y-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400 mb-3">Contatti</p>
          <a data-testid="footer-email" href={`mailto:${c.email}`} className="block text-slate-200 hover:text-white">{c.email}</a>
          <a data-testid="footer-phone" href={`tel:${String(c.phone).replace(/\s/g, "")}`} className="block text-slate-200 hover:text-white">{c.phone}</a>
        </div>
        <div className="md:col-span-4 text-sm space-y-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400 mb-3">Navigazione</p>
          <Link to="/programma" data-testid="footer-link-programma" className="block text-slate-200 hover:text-white">Il programma</Link>
          <Link to="/privacy" data-testid="footer-link-privacy" className="block text-slate-200 hover:text-white">Privacy e cookie policy</Link>
          <button data-testid="footer-cookie-prefs" onClick={() => window.dispatchEvent(new Event("open-cookie-prefs"))} className="block text-slate-200 hover:text-white">Preferenze cookie</button>
        </div>
      </div>
      <div className="border-t hairline">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-5 flex flex-col sm:flex-row gap-2 justify-between text-xs text-slate-400">
          <p>© {new Date().getFullYear()} {c.name} · {c.legal_name} · P.IVA {c.vat}</p>
          <p>{c.address}</p>
        </div>
      </div>
    </footer>
  );
};
